import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
http.interceptors.request.use((c) => {
  const t = localStorage.getItem("hot_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const useApi = (key, path, opts = {}) =>
  useQuery({ queryKey: [key, path], queryFn: async () => (await http.get(path)).data, ...opts });

export const useSettings = () => useApi("settings", "/settings", { staleTime: 5 * 60_000 });
export const useCourses = () => useApi("courses", "/courses");

export const track = (event, meta = {}) => {
  try {
    if (window.gtag) window.gtag("event", event, meta);
    if (window.fbq) window.fbq("trackCustom", event, meta);
    http.post("/track", { event, path: window.location.pathname, meta }).catch(() => {});
  } catch (_) {}
};

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const waLink = (settings, text = "Hi, I'd like to know more about programs at The House of Trading.") =>
  `https://wa.me/${settings?.whatsapp || "918264493626"}?text=${encodeURIComponent(text)}`;

export const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
